// Contact details shared by the hero, navbar, contact section and footer.
export const CALENDLY_URL = "https://calendly.com/juanpadin7/30min";
export const EMAIL = "info@venturasoftware.dev";
export const PHONE_DISPLAY = "+598 97 388 046";
export const PHONE_E164 = "+59897388046";
export const WHATSAPP_URL = "https://wa.me/59897388046";
